export const GET_FLAGS_REQUEST = "GET_FLAGS_REQUEST";
export const GET_FLAGS_SUCCESS = "GET_FLAGS_SUCCESS";
export const GET_FLAGS_FAILURE = "GET_FLAGS_FAILURE";
